<ng-template *ngIf="survey.isLogoBefore" [component]="{ name: survey.getElementWrapperComponentName(survey, 'logo-image'), data: { data: survey.getElementWrapperComponentData(survey, 'logo-image') } }"></ng-template>
<div
  *ngIf="survey.renderedHasTitle"
  [class]="survey.css.headerText"
  [style.maxWidth]="survey.titleMaxWidth"
>
  <sv-ng-element-title [element]="survey"></sv-ng-element-title>
  <div *ngIf="survey.renderedHasDescription" [class]="survey.css.description" [model]="survey.locDescription" sv-ng-string></div>
</div>

<ng-template *ngIf="survey.isLogoAfter" [component]="{ name: survey.getElementWrapperComponentName(survey, 'logo-image'), data: { data: survey.getElementWrapperComponentData(survey, 'logo-image') } }"></ng-template>
<div [class]="survey.css.headerClose"></div>